// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

export const authSlice = createSlice({
  name: 'appAuth',
  initialState: {
    user: null
  },
  reducers: {
    login: (state, action) => {
      state.user = action.payload
    },
    logout: state => {
      state.user = null
    }
  }
})
export const { login, logout } = authSlice.actions

export default authSlice.reducer
